
import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton, Typography, Box, TextField } from '@mui/material';
import { ModalClose } from '../../assets/icons';
import TickIcon from '../../assets/icons/mdiTickIcon';


interface EditIconModalProps {
    open: boolean;
    onClose: () => void;
    title: string;
    content: string;
    onConfirm: () => void;
}

const EditIconModal: React.FC<EditIconModalProps> = ({ open, onClose, onConfirm }) => {
    return (
        <Dialog open={open} onClose={onClose} className='card-details-modal' sx={{ '& .MuiDialog-paper': { width: '661px', maxWidth: '661PX', borderRadius: '24px', border: '1px solid #E8E8EA' } }}>
            <DialogTitle sx={{ m: 0, }} p={{ xs: "0 16px 16px", sm: "0 32px 32px" }}>
                <Typography color='#333333' fontSize={{ xs: "22px", sm: "28px" }} fontWeight='500' >Edit Domain</Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={() => ({
                        position: 'absolute',
                        right: { xs: "17px" },
                        top: { xs: "15px" },

                    })}
                >
                    <ModalClose></ModalClose>
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ borderTop: 'none', borderBottom: 'none', p: { xs: "0 16px 16px", sm: "0 32px 32px" } }}>
                <Box bgcolor="rgba(97, 78, 250, 0.08);" borderRadius="8px" padding="12px 10px" mb="40px">
                    <Typography component="span" fontWeight="600" color="#2B2B30" fontSize="16px">
                        Note:<Typography component="span" ml="4px">Special character's are not allowed in domain name. Please use numbers, letters or hyphen. Do not add www or extension like .com, .net, etc.</Typography>
                    </Typography>
                </Box>
                <Box display="flex" alignItems="center">
                    <Typography color='#333333' fontSize='14px' fontWeight='500' mb='12px' mr="12px" sx={{ opacity: '0.6' }}>https://</Typography>
                    <TextField
                        variant="outlined"
                        placeholder='StarfieldCorps'
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: '8px',
                                borderColor: '#C7C7C7',
                            },

                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: '#333333',
                                border: '1px solid'
                            },

                            "& .MuiOutlinedInput-input": {
                                padding: '14px 16px',
                            },
                            "&.MuiInputBase-input::placeholder": {
                                color: '#333333',
                                fontSize: '16px',
                                opacity: '0.8'
                            },

                        }}
                        fullWidth
                    />
                    <Box display="flex">
                        <Typography color="#333" fontSize="16px" fontWeight="500" margin="0 12px">.easycrm.io</Typography>
                        <TickIcon></TickIcon>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ mb: { xs: "16px", sm: "32px" }, mr: { xs: "11px", sm: "32px" } }}>
                <Button onClick={onClose} color="primary" sx={{
                    border: '1px solid #E8EAF0', px: '22px', color: '#2B2B30 !important', textTransform: 'capitalize', borderRadius: '8px', mr: '16px', '&:hover': {
                        border: '1px solid #E8EAF0 !important',
                        boxShadow: 'unset !important'
                    },
                }}>
                    Cancel
                </Button>
                <Button onClick={onConfirm} sx={{
                    textTransform: 'capitalize', bgcolor: '#614EFA', color: '#FFFFFF !important', px: '24px', height: '40px', borderRadius: '8px', '&:hover': {
                        border: 'none !important'
                    },
                }}>Save</Button>
            </DialogActions>
        </Dialog>
    );
};
export default EditIconModal;
